import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import * as S from "./styled";
import { Navigation } from "swiper/modules";
import { homeMainSlideLists } from "../../../data/home";
import Icon from "../../Icon";
import mainSlideArrowLeftIcon from "../../../assets/images/home/mainSlideArrowLeft.png";
import mainSlideArrowRightIcon from "../../../assets/images/home/mainSlideArrowRight.png";

const MainSlide = () => {
  const MainSlidePrevRef = useRef<HTMLButtonElement | null>(null);
  const MainSlideNextRef = useRef<HTMLButtonElement | null>(null);
  return (
    <S.MainSlideContainer
      data-aos="fade"
      data-aos-duration={600}
      data-aos-easing="linear"
    >
      <Swiper
        modules={[Navigation]} // Navigation 모듈 추가
        spaceBetween={0}
        slidesPerView={1}
        navigation={{
          prevEl: MainSlidePrevRef.current,
          nextEl: MainSlideNextRef.current,
        }}
        onSwiper={(swiper: any) => {
          setTimeout(() => {
            if (swiper?.params?.navigation) {
              // Swiper가 초기화된 후 버튼을 다시 연결
              Object.assign(swiper.params.navigation, {
                prevEl: MainSlidePrevRef.current,
                nextEl: MainSlideNextRef.current,
              });
              swiper.navigation.init();
              swiper.navigation.update();
            }
          });
        }}
      >
        {homeMainSlideLists.map((homeSlide, index) => (
          <SwiperSlide key={homeSlide.key + index}>
            <S.HomeMainSlideWrapper>
              <S.HomeMainSlideImgWrap>
                <img src={homeSlide.img} alt={homeSlide.key} />
              </S.HomeMainSlideImgWrap>
              <S.HomeMainSlideTextWrapper>
                <div className="inner">
                  <S.HomeMainSlideTextWrap>
                    <div>
                      <div className="title-wrap">
                        <p>{homeSlide.title}</p>
                        {homeSlide.subTitle ? (
                          <p>{homeSlide.subTitle}</p>
                        ) : null}
                      </div>
                      <span>{homeSlide.text}</span>
                    </div>
                  </S.HomeMainSlideTextWrap>
                </div>
              </S.HomeMainSlideTextWrapper>
            </S.HomeMainSlideWrapper>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Prev, Next 버튼 */}
      <S.MainSlideButtonWrapper>
        <div className="inner">
          <S.MainSlideButtonWrap>
            <S.MainSlidPrevButton ref={MainSlidePrevRef}>
              <Icon>
                <img src={mainSlideArrowLeftIcon} alt="logo" />
              </Icon>
            </S.MainSlidPrevButton>
            <S.MainSlidNextButton ref={MainSlideNextRef}>
              <Icon>
                <img src={mainSlideArrowRightIcon} alt="logo" />
              </Icon>
            </S.MainSlidNextButton>
          </S.MainSlideButtonWrap>
        </div>
      </S.MainSlideButtonWrapper>
    </S.MainSlideContainer>
  );
};

export default MainSlide;
